export type SteppedLine<T> = (data: T[]) => string;

export const steppedLine = <T>(
  xMapperFn: (d: T, idx: number, data: T[]) => number,
  yMapperFn: (d: T, idx: number, data: T[]) => number,
  lineChartAreaMaxWidth?: number
): SteppedLine<T> => {
  return (data: T[]): string => {
    let line = '';

    data.forEach((d, i) => {
      const y0 = yMapperFn(d, i, data);
      let x0 = xMapperFn(d, i, data);

      if (x0 < 0) {
        x0 = 0;
      }

      if (lineChartAreaMaxWidth && x0 > lineChartAreaMaxWidth) {
        x0 = lineChartAreaMaxWidth;
      }

      line += i === 0 ? `M${x0},${y0}` : `H${x0}`;

      line += `V${y0}`;
    });

    return line;
  };
};
